import * as Service from '../supplies-service';

export default {
  /**
   * Get all supplies
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllSupplies({ commit }) {
    const response = await Service.getAllSupplies();
    commit('setProperty', { property: 'supplies', payload: response });
  },

  /**
   *
   * @param commit
   * @param supplyId
   * @returns {Promise<void>}
   */
  async deleteSupply({ commit }, { supplyId }) {
    await Service.deleteSupply(supplyId);
    commit('delProperty', { property: supplyId });
  },

  /**
   *
   * @param context
   * @param supplyId
   * @param supply
   * @returns {Promise<void>}
   */
  async updateSupply(context, { supplyId, supply }) {
    await Service.updateSupply(supplyId, supply);
  },

  /**
   *
   * @param context
   * @param supply
   * @returns {Promise<void>}
   */
  async newSupply({ commit }, { supply }) {
    const response = await Service.newSupply(supply);
    commit('setNewSupply', { payload: response });
    commit('setProperty', { property: 'supply', payload: response });
  },

  /**
   *
   * @param context
   * @param supplyId
   * @returns {Promise<void>}
   */
  async getSupply({ commit }, supplyId) {
    const response = await Service.getSupply(supplyId);
    commit('setProperty', { property: 'supply', payload: response });
  },

  /**
   *
   * @param context
   * @param suppliedGood
   * @returns {Promise<void>}
   */
  async newSuppliedGood({ commit }, { suppliedGood }) {
    const response = await Service.newSuppliedGood(suppliedGood);
    commit('setNewSuppliedGood', { payload: response });
    commit('setSuppliedGood', { property: 'supplied_good', payload: response });
  },

  /**
   *
   * @param commit
   * @param suppliedGoodId
   * @param suppliedGood
   * @returns {Promise<void>}
   */
  async updateSuppliedGood({ commit }, { suppliedGoodId, suppliedGood }) {
    const response = await Service.updateSuppliedGood(suppliedGoodId, suppliedGood);
    commit('setSuppliedGood', { property: 'supplied_good', payload: response });
  },

  /**
   *
   * @param commit
   * @param suppliedGoodId
   * @returns {Promise<void>}
   */
  async deleteSuppliedGood({ commit }, { suppliedGoodId }) {
    await Service.deleteSuppliedGood(suppliedGoodId);
    commit('delSuppliedGood', { property: suppliedGoodId });
  },
};
